// Components==============
import showDream from 'actions/dream/show';
import PersonModal from 'components/UI/PersonModal/PersonModal';
import ProjectCard from 'components/UI/ProjectCard/ProjectCard';
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import SkillGetter from 'components/UI/SkillGetter/SkillGetter';
import Spark from 'components/UI/Spark/Spark';
import TokenGetter from 'components/UI/TokenGetter/TokenGetter';
import { useReduxAction } from 'hooks/useReduxAction';
import { useRootModal } from 'hooks/useRootModal';
import { useThemesWithProject } from 'hooks/useThemesWithProject';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useEffect } from 'react';
import { DreamModalContext } from '../DreamModal';
import DreamModalItem from '../DreamModalItem';
import DreamModalItems from '../DreamModalItems/DreamModalItems';
import './Content.module.scss';
// =========================

export default function Content() {
  const translate = useTranslate();
  const dispatch = useReduxAction();

  const { dream, activities, skills, people, originState } = useContext(
    DreamModalContext
  );

  const { setModal } = useRootModal();

  useEffect(() => {
    if (originState === 'view') dispatch(showDream(dream?.id));
  }, []);

  const themesWithProject = useThemesWithProject();

  const projects = themesWithProject.filter((t) =>
    dream?.contributed_projects?.includes(t?.project?.id || 0)
  );

  const sparks = dream?.reflections
    ?.map((r) => r.sparks)
    .flat()
    // filter duplicates
    .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);

  return (
    <div styleName="wrapper">
      <div>
        <h2>{dream?.name}</h2>
        <p>{dream?.description}</p>
      </div>
      {!!(activities?.length || skills?.length || people?.length) && (
        <div>
          <h2>{translate('dream.dream-come-true')}</h2>
          <div styleName="grid">
            {!!activities?.length && (
              <DreamModalItems
                title="project.terms.activities"
                items={
                  <>
                    {activities?.map((activity, i) => (
                      <DreamModalItem
                        key={i}
                        amount={activity.amount}
                        id={activity.requirement_id}
                        type={activity.requirement_type}
                        done={activity.done}
                      >
                        <TokenGetter requirement={activity} key={i} />
                      </DreamModalItem>
                    ))}
                  </>
                }
                itemLength={activities?.length || 0}
              />
            )}
            {!!skills?.length && (
              <DreamModalItems
                title="general.terms.skills"
                items={
                  <>
                    {skills?.map(
                      (skill) =>
                        skill && (
                          <DreamModalItem
                            key={skill.id}
                            amount={skill.amount}
                            id={skill.id}
                            done={skill.done}
                            type={'App\\Skill'}
                          >
                            <SkillGetter id={skill.requirement_id} />
                          </DreamModalItem>
                        )
                    )}
                  </>
                }
                itemLength={skills?.length || 0}
              />
            )}
            {!!people?.length && (
              <DreamModalItems
                title="reflection.terms.people"
                items={
                  <>
                    {people?.map(
                      (person) =>
                        person && (
                          <ReflectionIcon
                            key={person.id}
                            name={person.name}
                            image={`/storage/${person.image}`}
                            onClick={() =>
                              setModal(<PersonModal person={person} />)
                            }
                          />
                        )
                    )}
                  </>
                }
                itemLength={people?.length || 0}
              />
            )}
          </div>
        </div>
      )}
      {originState === 'view' &&
        !!(
          projects.length ||
          dream?.contributed_activities?.length ||
          sparks?.length
        ) && (
          <div>
            <h2>{translate('dream.terms.progress-made')}</h2>
            <div styleName="grid">
              {!!projects.length && (
                <div>
                  <h3>{translate('dream.projects-that-contributed')}</h3>
                  <div styleName="projects">
                    {projects?.map((theme) => (
                      <ProjectCard theme={theme} key={theme?.id} />
                    ))}
                  </div>
                </div>
              )}
              {!!dream?.contributed_activities?.length && (
                <DreamModalItems
                  title="dream.activities-that-contributed"
                  items={
                    <>
                      {dream.contributed_activities?.map(
                        (activity) =>
                          !!activity && (
                            <DreamModalItem
                              key={activity.id}
                              amount={activity?.amount}
                              id={activity.id}
                              type={activity.type}
                              contribution
                            >
                              <TokenGetter
                                activity={{
                                  process_type: activity.type,
                                  process_id: activity.id,
                                }}
                              />
                            </DreamModalItem>
                          )
                      )}
                    </>
                  }
                  itemLength={dream.contributed_activities?.length || 0}
                />
              )}
              {!!sparks?.length && (
                <div>
                  <h3>{translate('reflection.achieved-sparks')}</h3>
                  <div>
                    <div styleName="sparks">
                      {sparks?.map(
                        (spark, i) => !!spark && <Spark spark={spark} key={i} />
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div />
            </div>
          </div>
        )}
    </div>
  );
}
